import { render, staticRenderFns } from "./equitiesApply.vue?vue&type=template&id=574ad4b5&scoped=true&"
import script from "./equitiesApply.vue?vue&type=script&lang=js&"
export * from "./equitiesApply.vue?vue&type=script&lang=js&"
import style0 from "./equitiesApply.vue?vue&type=style&index=0&id=574ad4b5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574ad4b5",
  null
  
)

export default component.exports